import { ReducerChain, withScope } from "@gamedev-web/gamedev-sdk-core";

import { GameConceptSellerDetails } from "../../models/gameConceptSellerDetails";
import {
  gameConceptPageActions,
  GameConceptPageActions,
  GameConceptPageData,
} from "../actions/gameConceptPageActions";
import { GameConceptPageScope } from "../scopes";

export type GameConceptPageState = {
  isLoading: boolean;
  isSaving: boolean;
  isSubmitting: boolean;
  data: GameConceptPageData | null;
  error: string | null;
  sellerDetails: GameConceptSellerDetails | null;
  sellerDetailsGameConceptId: string | null;
  isSellerDetailsLoading: boolean;
  sellerDetailsError: string | null;
  isSavingStoreId: boolean;
  storeIdError: string | null;
};

export const initialGameConceptPageState: GameConceptPageState = {
  isLoading: false,
  isSaving: false,
  isSubmitting: false,
  data: null,
  error: null,
  sellerDetails: null,
  sellerDetailsGameConceptId: null,
  isSellerDetailsLoading: false,
  sellerDetailsError: null,
  isSavingStoreId: false,
  storeIdError: null,
};

export const gameConceptPageReducer = withScope(
  [GameConceptPageScope],
  new ReducerChain<GameConceptPageState>(initialGameConceptPageState)
    .on(GameConceptPageActions.FETCH_START, () => ({
      ...initialGameConceptPageState,
      isLoading: true,
    }))
    .on(GameConceptPageActions.FETCH_COMPLETED, (state, action) => ({
      ...state,
      isLoading: false,
      data: (action as unknown as { data: GameConceptPageData }).data,
      error: null,
    }))
    .on(GameConceptPageActions.FETCH_ERROR, (state, action) => ({
      ...state,
      isLoading: false,
      error: (action as unknown as { error: Error }).error.message,
    }))
    .on(gameConceptPageActions.fetchSellerDetails.start, (state, action) =>
      state.data?.gameConceptId !== action.gameConceptId
        ? state
        : {
            ...state,
            sellerDetails: null,
            sellerDetailsGameConceptId: action.gameConceptId,
            isSellerDetailsLoading: true,
            sellerDetailsError: null,
          }
    )
    .on(gameConceptPageActions.saveStoreId.start, (state, action) =>
      state.data?.gameConceptId !== action.gameConceptId
        ? state
        : { ...state, isSavingStoreId: true, storeIdError: null }
    )
    .on(gameConceptPageActions.saveStoreId.success, (state, action) =>
      state.data?.gameConceptId !== action.gameConceptId
        ? state
        : {
            ...state,
            isSavingStoreId: false,
            storeIdError: null,
            data: { ...state.data, bigId: action.bigId, canAddStoreId: false },
          }
    )
    .on(gameConceptPageActions.saveStoreId.error, (state, action) =>
      state.data?.gameConceptId !== action.gameConceptId
        ? state
        : { ...state, isSavingStoreId: false, storeIdError: action.error.message }
    )
    .on(gameConceptPageActions.fetchSellerDetails.success, (state, action) =>
      state.sellerDetailsGameConceptId !== action.gameConceptId
        ? state
        : {
            ...state,
            sellerDetails: action.sellerDetails,
            isSellerDetailsLoading: false,
            sellerDetailsError: null,
          }
    )
    .on(gameConceptPageActions.fetchSellerDetails.error, (state, action) =>
      state.sellerDetailsGameConceptId !== action.gameConceptId
        ? state
        : {
            ...state,
            sellerDetails: null,
            isSellerDetailsLoading: false,
            sellerDetailsError: action.error.message,
          }
    )
    .on(GameConceptPageActions.SAVE_START, state => ({
      ...state,
      isSaving: true,
      error: null,
    }))
    .on(GameConceptPageActions.SAVE_COMPLETED, state => ({
      ...state,
      isSaving: false,
      error: null,
    }))
    .on(GameConceptPageActions.SAVE_ERROR, (state, action) => ({
      ...state,
      isSaving: false,
      error: (action as unknown as { error: Error }).error.message,
    }))
    .on(GameConceptPageActions.SUBMIT_START, state => ({
      ...state,
      isSubmitting: true,
      error: null,
    }))
    .on(GameConceptPageActions.SUBMIT_COMPLETED, state => ({
      ...state,
      isSubmitting: false,
      error: null,
    }))
    .on(GameConceptPageActions.SUBMIT_ERROR, (state, action) => ({
      ...state,
      isSubmitting: false,
      error: (action as unknown as { error: Error }).error.message,
    }))
    .build()
);
